import React, { Component } from 'react'
import { connect } from 'react-redux'

import './_smartInput.css'

class SmartInput extends Component {
  static defaultProps = {
    tips: [],
    defaultValue: '',
    placeholder: 'Введите',
    onValueChanged: () => {}
  }

  constructor(props) {
    super(props)
    this.state = {
      value: '',
      defaultValue: props.defaultValue,
      selected: 1,
      isTipsOpened: false,
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({value: nextProps.defaultValue})
    this.props.onValueChanged(nextProps.defaultValue)
  }

  handleTipsOpen = () => { 
    this.setState({isTipsOpened: true})
    if(this.state.value === this.state.defaultValue) {
      this.setState({value: '', defaultValue: ''})
    }
  }

  handleTipsClose = (event) => { 
    this.setState({isTipsOpened: false})
  }

  handleSelectionChange = (event) => {
    var newValue = event.target.innerHTML
    this.setState({value: newValue})
    this.handleTipsClose()
    this.props.onValueChanged(newValue)
  }

  handleInputChange = (event) => {
    var newValue = event.target.value
    this.setState({value: newValue})
    this.props.onValueChanged(newValue)
  }

  render() {
    const { tips, placeholder } = this.props
    const { isTipsOpened, value } = this.state

    return (
      <div className="smart-input">
        <input type="text"
          placeholder={placeholder}
          value={value}
          onChange={this.handleInputChange}
          onFocus={this.handleTipsOpen} 
          onBlur={this.handleTipsClose} />

        <ul className={`tips-list ${(isTipsOpened) ? 'opened' : ''}`}>
        <li className="chose">или выберите:</li>
        {tips.map(item => {
          return <li onMouseDown={this.handleSelectionChange} key={item.id}>{item.value}</li>
        })}
        </ul>
      </div>
    );
  }
}

export default connect()(SmartInput)


// WEBPACK FOOTER //
// ./src/components/smart-input/SmartInput.js